import Cookies from "js-cookie"
import {useEffect} from "react"
import {useDispatch} from "react-redux"
import {Action, ThunkDispatch} from "@reduxjs/toolkit"
import {FILTER_SETTINGS_COOKIE} from "../../config/constants"
import {FilterCookie} from "../../models/cookie"
import {updateFiltersOpenFromCookie, updateFiltersOpenFromFacets} from "../../ducks/search"
import {removeCookieFromCurrentDomain} from "../../utils/removeCookieFromDomain"
import State from "../../models/State"

export const useSetFiltersOpenFromCookie = (url: string, rememberFilters: boolean) => {
    const dispatch = useDispatch<ThunkDispatch<State, null, Action>>()

    useEffect(() => {
        if (!rememberFilters) {
            removeCookieFromCurrentDomain(FILTER_SETTINGS_COOKIE, url)
            // startTransition(() => dispatch(updateFiltersOpenFromFacets()))
            dispatch(updateFiltersOpenFromFacets())
            return
        }
        const filterCookie = Cookies.getJSON(FILTER_SETTINGS_COOKIE) as FilterCookie
        if (filterCookie) {
            // startTransition(() => dispatch(updateFiltersOpenFromCookie(filterCookie)))
            dispatch(updateFiltersOpenFromCookie(filterCookie))
        }
    }, [])
}

export default useSetFiltersOpenFromCookie
